import Call from '../Call.v2';
import {objToQs} from '../Utils';

const Pushapi = {
    get(filters, path = '') {
        return Call(`pushapi/report/${path}?${objToQs(filters)}`);
    },
};

export default Pushapi;



// WEBPACK FOOTER //
// ./src/services/API/components/Pushapi.v2.js